import { join, map, prop } from 'ramda';
import { isNotNilOrEmpty } from 'ramda-adjunct';

const addStylesColorsVariables = (styles) => {
  const stylesVars = map((style) => {
    const uuid = prop('uuid', style);
    const properties = prop('styles', style);
    const colorValue = prop('color', properties);
    const bgColorValue = prop('background-color', properties);

    const colorVar = isNotNilOrEmpty(colorValue) ? `--${uuid}-text-color:${colorValue};` : '';
    const bgColorVar = isNotNilOrEmpty(bgColorValue) ? `--${uuid}-bg-color:${bgColorValue};` : '';
    return join('', [colorVar, bgColorVar]);
  })(styles);
  return join('', stylesVars);
};

const addColorsVariables = (colors) => {
  const colorsVars = map((color) => `--${prop('uuid', color)}:${prop('color', color)};`, colors);
  return join('', colorsVars);
};

export const generateCssVariables = (colors, styles) => {
  const colorsStr = addColorsVariables(colors);
  const stylesStr = addStylesColorsVariables(styles);
  return `:root{${colorsStr}\n${stylesStr}}`;
};
